import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { CaseStudiesHero } from "@/components/case-studies/HeroSection";
import { CaseStudyTabs } from "@/components/case-studies/CaseStudyTabs";
import { CaseStudiesCTA } from "@/components/case-studies/CaseStudiesCTA";

// Map case study IDs to their tab
const idToTab: Record<string, string> = {
  dental: "services",
  "smile-dental": "services",
  "flaming-tikkas": "restaurants",
  maac: "education",
  nsdt: "education",
  insd: "education",
  frameboxx: "education",
};

const CaseStudies = () => {
  const location = useLocation();
  const hash = location.hash.replace("#", "");
  const [activeTab, setActiveTab] = useState(() => idToTab[hash] || "education");

  useEffect(() => {
    if (hash && idToTab[hash]) {
      setActiveTab(idToTab[hash]);
      setTimeout(() => {
        const el = document.getElementById(hash);
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }, 300);
    }
  }, [hash]);

  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <main className="pt-16">
        <CaseStudiesHero />
        <CaseStudyTabs activeTab={activeTab} onTabChange={setActiveTab} />
        <CaseStudiesCTA />
      </main>
      <Footer />
    </div>
  );
};

export default CaseStudies;
